module.exports = __webpack_public_path__ + "prod/20260402160127/img/service.edbff227.png";